import { DateTime } from 'luxon';
import numeral from 'numeral';

// ===== Global Goals Utility F'ns =====

// Temporary amount formatter, issues with formatAmount
export const fmtAmt = (amt) => numeral(amt).format('$0,0');

export const fmtAmtWithDecimals = (amt) => numeral(amt).format('$0,0.00');

export const calcMonthlyDiff = ({ monthlyContribution, targetAmount, targetDate, savedSoFar = 0, startDate }) => {
  const startDateToUse = (startDate || DateTime.local()).startOf('month');
  const leftToSave = targetAmount - savedSoFar || targetAmount;
  const monthsToEnd = Math.ceil(targetDate.diff(startDateToUse, 'months').toObject().months || 0);
  const numMonths = monthlyContribution ? leftToSave / monthlyContribution : 0;
  const numMonthsRounded = Number.isFinite(numMonths) ? Math.ceil(numMonths) : 5988;
  const idealHitDate = startDateToUse.plus({ months: numMonthsRounded });
  const idealValue = monthsToEnd ? Math.ceil((leftToSave / monthsToEnd) * 100) / 100 : 0;
  return { idealHitDate, idealValue };
};

export const getAverageContribution = (goal, initialContribution = 0) => {
  if (!goal) return 0;
  const startDate = DateTime.fromISO(goal.startOn).startOf('month');
  const monthsDiff = Math.ceil(DateTime.local().diff(startDate, 'months').months);
  return monthsDiff < 1 ? (goal.savedSoFar - initialContribution) / monthsDiff : goal.savedSoFar - initialContribution;
};

export const calculateExpectedEndDate = (goal, averageContribution, thisMonthsContribution) => {
  const plannedContribution = goal.contributionAmount || 0;
  const today = DateTime.local().startOf('month');

  if (goal.savedSoFar === 0 && plannedContribution === 0 && !goal.targetOn) {
    return today.plus({ months: 12 });
  }

  const regularContribution = Math.max(plannedContribution, averageContribution) || goal.savedSoFar;
  if (!regularContribution) return undefined;

  const balanceAtEndOfThisMonth =
    plannedContribution && thisMonthsContribution >= plannedContribution
      ? // if user HAS met/exceeded this months contribution
        Number(goal.savedSoFar) // if the user has met the contribution for this month we assume they won't save more
      : Number(goal.savedSoFar) + plannedContribution - thisMonthsContribution; // otherwise we assume they will hit their contribution
  const monthsLeft =
    Math.ceil(Math.max(Number(goal.targetAmount) - balanceAtEndOfThisMonth, 0) / regularContribution) || 1; // calculate number of months after this one

  const goalStartOn = DateTime.fromISO(goal.startOn);

  let startDate = today > goalStartOn ? today : goalStartOn; // if it's a month that's past the start we start on this month otherwise on the start date
  // if they've started saving this month then push back to end of month, otherwise include this month
  startDate = balanceAtEndOfThisMonth > 0 ? startDate.endOf('month') : startDate.minus({ days: 1 });
  return startDate.plus({ months: monthsLeft }); // add number of months left
};
